define('admin/teams/users',['jquery', 'plugins/http', 'knockout', 'durandal/app'], function($, http, ko, app) {
    var viewmodel = function() {
        var self = this;

        self.page = 1;
        self.canLoadMore = ko.observable(false);
        self.loading = ko.observable(false);
        self.totalUsers = ko.observable(0);
        self.users = ko.observableArray([]);
        self.hasUsers = ko.computed(function () {
            return self.users().length > 0;
        });
        self.renderedUsers = ko.computed(function() {
            var data = self.users();
            var times = Math.ceil(data.length / 2);
            var result = [];
          
            for (var i = 0; i < times; i ++) {
                result.push(data.slice(i * 2, i * 2 + 2));
            }

            return result;
        });

        self.activate = function (inviteUserFunc,editUserFunc) {
            self.transitionToInviteUsersScreen = inviteUserFunc;
            self.transitionToEditUserScreen = editUserFunc;

            self.refresh();
        };

        self.refresh = function () {
            self.users.removeAll();

            self.loadNextPageOfUsers();
        };

        self.loadNextPageOfUsers = function() {
            self.getCompanyUsers()
                .then(self.processCompanyUsers)
                .fail(app.showError);
        };

        self.getCompanyUsers = function () {
            self.loading(true);

            var url = '/api/admin/users/company/' + self.page;

            return http.get(url);
        };

        self.processCompanyUsers = function (response) {
            self.loading(false);
            self.canLoadMore(response.data.moreToCome);
            self.totalUsers(response.data.total);

            if (response.data.moreToCome) {
                self.page++;
            }

            ko.utils.arrayPushAll(self.users, response.data.users);
        };

        self.getFormattedUserTeams = function (teams) {
            return teams.join(', ');
        };

        self.inviteUser = function () {
            self.transitionToInviteUsersScreen();
        };

        self.editUser = function (user) {
            self.transitionToEditUserScreen(user);
        };

        self.disableUserCommand = function(user) {
            var userId = user.id;

            self.disableUser(userId)
                .then(self.refresh)
                .fail(app.showError);
        };

        self.disableUser = function (userId) {
            var url = '/api/admin/teams/disableuser',
                data = {
                    userId: userId
                };

            return http.post(url, data);
        };
    };

    return viewmodel;
});

